"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = {
  moveToLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateX(-100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveFromLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateX(-100%)};"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveToRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateX(100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveFromRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateX(100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveToTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateY(-100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveFromTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateY(-100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveToBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateY(100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveFromBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateY(100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  fade: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveToLeftFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(-100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveFromLeftFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(-100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveToRightFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveFromRightFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveToTopFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(-100%);}"]),
    duration: 600,
    timing: 'ease',
    fill: 'both'
  },
  moveFromTopFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(-100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveToBottomFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  moveFromBottomFade: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(100%);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  scaleDown: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:scale(0.8);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  scaleUp: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:scale(0.8);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both'
  },
  scaleUpDown: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:scale(1.2);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both'
  },
  scaleDownUp: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:scale(1.2);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both'
  },
  scaleDownCenter: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:scale(0.7);}"]),
    duration: 400,
    timing: 'ease',
    fill: 'both'
  },
  scaleUpCenter: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:scale(0.7);}"]),
    duration: 400,
    timing: 'ease',
    fill: 'both'
  },
  rotateRightSideFirst: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}40%{transform:rotateY(15deg);opacity:0.8;animation-timing-function:ease-out;}100%{transform:scale(0.8) translateZ(-200px);opacity:0;}"]),
    duration: 800,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateLeftSideFirst: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}40%{transform:rotateY(-15deg);opacity:0.8;animation-timing-function:ease-out;}100%{transform:scale(0.8) translateZ(-200px);opacity:0;}"]),
    duration: 800,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateTopSideFirst: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}40%{transform:rotateX(15deg);opacity:0.8;animation-timing-function:ease-out;}100%{transform:scale(0.8) translateZ(-200px);opacity:0;}"]),
    duration: 800,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateBottomSideFirst: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}40%{transform:rotateX(-15deg);opacity:0.8;animation-timing-function:ease-out;}100%{transform:scale(0.8) translateZ(-200px);opacity:0;}"]),
    duration: 800,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  flipOutRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateZ(-1000px) rotateY(90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 50%'
  },
  flipInLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateZ(-1000px) rotateY(-90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-out',
    fill: 'both',
    origin: '50% 50%'
  },
  flipOutLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateZ(-1000px) rotateY(-90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 50%'
  },
  flipInRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateZ(-1000px) rotateY(90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-out',
    fill: 'both',
    origin: '50% 50%'
  },
  flipOutTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateZ(-1000px) rotateX(90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 50%'
  },
  flipInBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateZ(-1000px) rotateX(-90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-out',
    fill: 'both',
    origin: '50% 50%'
  },
  flipOutBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateZ(-1000px) rotateX(-90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 50%'
  },
  flipInTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateZ(-1000px) rotateX(90deg);opacity:0.2;}"]),
    duration: 500,
    timing: 'ease-out',
    fill: 'both',
    origin: '50% 50%'
  },
  rotateFall: {
    keyframes: (0, _styledComponents.keyframes)(["0%{transform:rotateZ(0deg);}20%{transform:rotateZ(10deg);animation-timing-function:ease-out;}40%{transform:rotateZ(17deg);}60%{transform:rotateZ(16deg);}100%{transform:translateY(100%) rotateZ(17deg);}"]),
    duration: 1000,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 0%'
  },
  rotateOutNewspaper: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{transform:translateZ(-3000px) rotateZ(360deg);opacity:0;}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 50%'
  },
  rotateInNewspaper: {
    keyframes: (0, _styledComponents.keyframes)(["from{transform:translateZ(-3000px) rotateZ(-360deg);opacity:0;}"]),
    duration: 500,
    timing: 'ease-out',
    fill: 'both',
    origin: '50% 50%'
  },
  rotatePushLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:rotateY(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotatePushRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:rotateY(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotatePushTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:rotateX(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotatePushBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:rotateX(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotatePullRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:rotateY(-90deg);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotatePullLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:rotateY(90deg);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotatePullTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:rotateX(-90deg);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotatePullBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:rotateX(90deg);}"]),
    duration: 500,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateFoldRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:translateX(100%) rotateY(90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateFoldLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:translateX(-100%) rotateY(-90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateFoldTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:translateY(-100%) rotateX(90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateFoldBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:translateY(100%) rotateX(-90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateUnfoldLeft: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateX(-100%) rotateY(-90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateUnfoldRight: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateX(100%) rotateY(90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateUnfoldTop: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateY(-100%) rotateX(90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateUnfoldBottom: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateY(100%) rotateX(-90deg);}"]),
    duration: 700,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateRoomLeftOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(-100%) rotateY(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateRoomLeftIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(100%) rotateY(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateRoomRightOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(100%) rotateY(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateRoomRightIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(-100%) rotateY(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateRoomTopOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(-100%) rotateX(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateRoomTopIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(100%) rotateX(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateRoomBottomOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(100%) rotateX(90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateRoomBottomIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(-100%) rotateX(-90deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateCubeLeftOut: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}50%{animation-timing-function:ease-out;transform:translateX(-50%) translateZ(-200px) rotateY(-45deg);}100%{opacity:0.3;transform:translateX(-100%) rotateY(-90deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateCubeLeftIn: {
    keyframes: (0, _styledComponents.keyframes)(["0%{opacity:0.3;transform:translateX(100%) rotateY(90deg);}50%{animation-timing-function:ease-out;transform:translateX(50%) translateZ(-200px) rotateY(45deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateCubeRightOut: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}50%{animation-timing-function:ease-out;transform:translateX(50%) translateZ(-200px) rotateY(45deg);}100%{opacity:0.3;transform:translateX(100%) rotateY(90deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateCubeRightIn: {
    keyframes: (0, _styledComponents.keyframes)(["0%{opacity:0.3;transform:translateX(-100%) rotateY(-90deg);}50%{animation-timing-function:ease-out;transform:translateX(-50%) translateZ(-200px) rotateY(-45deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateCubeTopOut: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}50%{animation-timing-function:ease-out;transform:translateY(-50%) translateZ(-200px) rotateX(45deg);}100%{opacity:0.3;transform:translateY(-100%) rotateX(90deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateCubeTopIn: {
    keyframes: (0, _styledComponents.keyframes)(["0%{opacity:0.3;transform:translateY(100%) rotateX(-90deg);}50%{animation-timing-function:ease-out;transform:translateY(50%) translateZ(-200px) rotateX(-45deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateCubeBottomOut: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}50%{animation-timing-function:ease-out;transform:translateY(50%) translateZ(-200px) rotateX(-45deg);}100%{opacity:0.3;-webkit-transform:translateY(100%) rotateX(-90deg);transform:translateY(100%) rotateX(-90deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateCubeBottomIn: {
    keyframes: (0, _styledComponents.keyframes)(["0%{opacity:0.3;-webkit-transform:translateY(-100%) rotateX(90deg);transform:translateY(-100%) rotateX(90deg);}50%{animation-timing-function:ease-out;transform:translateY(-50%) translateZ(-200px) rotateX(45deg);}"]),
    duration: 600,
    timing: 'ease-in',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateCarouselLeftOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(-150%) scale(0.4) rotateY(-65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateCarouselLeftIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(200%) scale(0.4) rotateY(65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateCarouselRightOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateX(200%) scale(0.4) rotateY(65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '0% 50%'
  },
  rotateCarouselRightIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateX(-200%) scale(0.4) rotateY(-65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '100% 50%'
  },
  rotateCarouselTopOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(-200%) scale(0.4) rotateX(65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateCarouselTopIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(200%) scale(0.4) rotateX(-65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateCarouselBottomOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0.3;transform:translateY(200%) scale(0.4) rotateX(-65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 0%'
  },
  rotateCarouselBottomIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0.3;transform:translateY(-200%) scale(0.4) rotateX(65deg);}"]),
    duration: 800,
    timing: 'ease',
    fill: 'both',
    origin: '50% 100%'
  },
  rotateSidesOut: {
    keyframes: (0, _styledComponents.keyframes)(["from{}to{opacity:0;transform:translateZ(-500px) rotateY(90deg);}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '-50% 50%'
  },
  rotateSidesIn: {
    keyframes: (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateZ(-500px) rotateY(-90deg);}"]),
    duration: 500,
    timing: 'ease-in',
    fill: 'both',
    origin: '150% 50%'
  },
  rotateSlideOut: {
    keyframes: (0, _styledComponents.keyframes)(["0%{}25%{opacity:0.5;transform:translateZ(-500px);}75%{opacity:0.5;transform:translateZ(-500px) translateX(-200%);}100%{opacity:0.5;transform:translateZ(-500px) translateX(-200%);}"]),
    duration: 1000,
    timing: 'ease',
    fill: 'both'
  },
  rotateSlideIn: {
    keyframes: (0, _styledComponents.keyframes)(["0%,25%{opacity:0.5;transform:translateZ(-500px) translateX(200%);}75%{opacity:0.5;transform:translateZ(-500px);}100%{opacity:1;transform:translateZ(0) translateX(0);}"]),
    duration: 1000,
    timing: 'ease',
    fill: 'both'
  }
};
exports["default"] = _default;